import { createAction } from "@reduxjs/toolkit";

import { UiStreamAction } from "@intelligems/ig-types/schemas/ai/ui-stream-actions";

/**
 * Per-stream-message trigger for the Viv visual-builder chat, dispatched by
 * `useVivChatBridge` in place of a raw `handleAiChatAction`. The side-effect
 * listener keys on it to both forward the message to the chat UI and drive
 * continuations — scoped to Viv so the experience-creation chat is untouched.
 */
export const vivStreamAction = createAction<{ data: UiStreamAction }>(
  "experienceBuilderAi/vivStreamAction"
);

/**
 * Aborts an in-flight continuation sequence. Dispatched by `stopVivChat` so a
 * stopped turn never fires its queued continuation; the side-effect listener
 * races this against the turn's terminal (`finish`) event.
 */
export const cancelContinuation = createAction(
  "experienceBuilderAi/cancelContinuation"
);
